// composables/permissions/usePermissions.ts
import { useAuthStore } from '~/stores/auth'
import type { Rol } from '~/types/rol'
import type { Permission } from '~/types/permission'

export function usePermissions() {
  const authStore = useAuthStore()

  const hasPermission = (code: string): boolean => {

    // ==========================
    // CUSTOMER
    // ==========================
    if (authStore.sessionType === 'customer') {
      return authStore.customerPermissions.includes(code)
    }

    // ==========================
    // INTERNAL
    // ==========================
    const tenant = authStore.selectedTenant
    if (!tenant || !tenant.roles) return false

    return tenant.roles.some((role: Rol) =>
      role.permissions?.some((permission: Permission) => permission.code === code)
    )
  }

  const allPermissions = (): Permission[] => {

    if (authStore.sessionType === 'customer') {
      return authStore.customerPermissions.map(code => ({
        code
      } as Permission))
    }

    const tenant = authStore.selectedTenant
    if (!tenant || !tenant.roles) return []

    const permisos = tenant.roles.flatMap((role: Rol) => role.permissions)
    const unique: Record<string, Permission> = {}

    permisos.forEach((permission: Permission) => {
      unique[permission.code] = permission
    })

    return Object.values(unique)
  }

  const getPermission = (code: string): Permission | undefined => {
    return allPermissions().find(permission => permission.code === code)
  }

  return { hasPermission, allPermissions, getPermission }
}